module.exports = __webpack_public_path__ + "img/ganar-dinero-viajando.2e1f64b4.png";